/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { useT } from "@/lib/i18n";

const FACEBOOK_URL = "https://www.facebook.com/share/182xo56fwH/";

export default function Footer() {
  const t = useT();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#FAFAF7] border-t border-[#E2E4DF] py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-full bg-[#1C3A27] grid place-items-center">
              <span className="w-3 h-3 rounded-full bg-[#E05A3D]" />
            </span>
            <span className="font-display text-xl font-bold tracking-tight text-[#1C3A27]">
              {t.brand.name}
            </span>
          </div>
          <p className="mt-4 text-sm text-[#5C6B5C] max-w-xs">
            {t.footer.tagline}
          </p>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            aria-label="Suivez-nous sur Facebook"
            className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#1877F2] hover:bg-[#0F5FCC] text-white text-sm font-semibold transition-colors shadow-sm"
          >
            <Facebook size={18} />
            Suivez-nous sur Facebook
          </a>
        </div>

        <div className="grid grid-cols-2 gap-8 md:col-span-2 md:justify-self-end md:text-end">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#1C3A27]">
              {t.footer.col_product}
            </div>
            <ul className="mt-4 space-y-2 text-sm text-[#5C6B5C]">
              <li>
                <a href="#features" className="hover:text-[#1C3A27]">
                  {t.nav.features}
                </a>
              </li>
              <li>
                <a href="#pricing" className="hover:text-[#1C3A27]">
                  {t.nav.pricing}
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-[#1C3A27]">
                  {t.nav.faq}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#1C3A27]">
              {t.footer.col_company}
            </div>
            <ul className="mt-4 space-y-2 text-sm text-[#5C6B5C]">
              <li>
                <a href="#contact" className="hover:text-[#1C3A27]">
                  {t.nav.contact}
                </a>
              </li>
              <li dir="ltr">{t.contact.email}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-10 pt-6 border-t border-[#E2E4DF] flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#5C6B5C]">
        <div>
          © {new Date().getFullYear()} {t.brand.name} — {t.footer.rights}.
        </div>
        <div className="flex items-center gap-6">
          <Link to="/legal/mentions" data-testid="footer-mentions" className="hover:text-[#1C3A27]">
            {t.footer.legal}
          </Link>
          <Link to="/legal/privacy" data-testid="footer-privacy" className="hover:text-[#1C3A27]">
            {t.footer.privacy}
          </Link>
          <Link to="/legal/cgu" data-testid="footer-cgu" className="hover:text-[#1C3A27]">
            {t.footer.cgv}
          </Link>
        </div>
      </div>
    </footer>
  );
}
